import { ALTERAR_TIPO_EMISSAO_PASSAGEIRO_IDA } from '../types'

export default function alterarTipoEmissaoPassageiroIda (passageiro) {
  return {
    type: ALTERAR_TIPO_EMISSAO_PASSAGEIRO_IDA,
    payload: passageiro
  }
}
